/*@ngInject*/
const UserGroupEditorModel = function ($rootScope, coreConstant, userMediator) {

    let userGroup = {};
    let userGroupEditorModel = {};

    this.hasUnsavedChanges = false;
    this.isValid = false;

    this.reset = function (userGroupId) {
        if (!_.isNil(userGroupId)) {
            userGroupEditorModel[userGroupId] = {
                updateUserGroup: null,
                isValid: null,
                isValidToSave: null
            };
        } else {
            userGroupEditorModel = {};
        }
    };

    this.buildUserGroup = function (userGroupId) {
        this.reset(userGroupId);

        if (userGroupId === -1) {
            this.updateUserGroup({
                id: -1,
                name: null,
                status: 1,
                autoAssign: false,
                userRolesInfos: []
            });
        } else {
            userMediator.loadUserGroupById(userGroupId).then((userGroup) => {
                this.updateUserGroup(userGroup);
            });
        }
    };

    this.updateUserGroup = function (userGroup) {
        let model = {
            userGroup: _.cloneDeep(userGroup),
            isValid: null,
            isValidToSave: null
        };

        userGroupEditorModel[userGroup.id] = model;
        $rootScope.$broadcast(coreConstant.event.USER_GROUP_EDITOR_MODEL_UPDATED, userGroup.id);
    };

    this.getUserGroup = function (userGroupId) {
        let model = userGroupEditorModel[userGroupId];
        return model.userGroup;
    };

    this.setUserGroup = function (userGroup) {
        let model = {
            userGroup: _.cloneDeep(userGroup),
        };
        userGroupEditorModel[userGroup.id] = model;
    };

};

angular.module('umCore')
    .service('userGroupEditorModel', UserGroupEditorModel);
